export const updateCount = (isFollowing) => {
  const $element = document.querySelector('#js-followlist-count');
  const count = Number($element.textContent);
  if (isFollowing) {
    $element.textContent = count + 1;
  } else {
    $element.textContent = count - 1;
  }
};
